

























































import { Component, Vue } from "vue-property-decorator";
import { ruleBase, ruleDetail } from "@/req/commonity";
@Component
export default class Logout extends Vue {
  public tabId = 0;
  public modulesList: any = [];
  public contentList: any = [];
  public bannerList = [];

  public async mounted() {
    await this.getRuleBase();
    await this.getRuleDetail();
  }

  public async getRuleBase() {
    const res = await ruleBase();
    if (res.code == 200) {
      this.$emit("getText", res.data.rule_overview);
      this.modulesList = res.data.modules;
      this.bannerList = res.data.banners;
    }
  }

  public async getRuleDetail() {
    const res = await ruleDetail({
      module_id: this.modulesList[this.tabId].id,
    });
    if (res.code == 200) {
      this.contentList = res.data.list;
    }
  }

  public onTab(i) {
    if (this.tabId === i) return;
    this.tabId = i;
    this.getRuleDetail();
  }

  // icon区域跳转
  public goDetails(item) {
    // 在Vue组件中
    this.$router.push({
      path: "/Nesting/communityStandardDetails",
      query: { module_id: item.module_id, id: item.id },
    });
  }

  public goBanner(e, i) {
    (window as any).sendEditorEditorBanner(JSON.stringify(e));
  }
}
